package org.example.site_web.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Background
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.attr
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Canvas2d
import com.varabyte.kobweb.silk.components.graphics.ONE_FRAME_MS_60_FPS
import kotlinx.coroutines.delay
import org.example.site_web.components.sections.save
import org.example.site_web.content.accelargeBigTriangle
import org.example.site_web.content.accelargeSmallTriangle
import org.example.site_web.to3d.A2DVertex
import org.example.site_web.to3d.A3DTransform
import org.jetbrains.compose.web.css.Color.white
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.CanvasPattern
import org.w3c.dom.Image


@Composable
fun AnimatedLogo(
    rot: MutableState<Double>,
    modifier: Modifier = Modifier,
) {

    var loadedImag by remember { mutableStateOf(Image()) }
    LaunchedEffect(Unit) {
        val img = Image()
        img.src = "assets/degrade.png"
        img.onload = { evt ->
            loadedImag = img
            console.log("Loaded OK")
        }
    }
    Canvas2d(
        135,
        172,
        modifier
            .objectFit(ObjectFit.Fill)
            .background(Background.None)
            .border {
                color(Colors.White)
                style(LineStyle.None)
            }
            .attr("image-rendering", "smooth"),
        minDeltaMs = ONE_FRAME_MS_60_FPS * 5
    ) {
        ctx.imageSmoothingEnabled

        //TODO: Améliorer le moteur...

        ctx.clearRect(0.0, 0.0, width.toDouble(), height.toDouble())
        ctx.save {
            var pattern: CanvasPattern? = null

            ctx.fillStyle = "black"//pattern
            pattern = ctx.createPattern(loadedImag, "no-repeat")
            ctx.fillStyle = pattern

            var listOrigFaces = listOf(accelargeBigTriangle)
            var listFaces = mutableListOf<List<A2DVertex>>()
            for (face in listOrigFaces) {
                val temp = mutableListOf<A2DVertex>()
                for (v in face) {
                    temp.add(A3DTransform(180.0f + rot.value).doRotTo2D(v).doTrans2D(68.0,85.0))
                }
                listFaces.add(temp)
            }
            ctx.strokeStyle = "white"
            //ctx.fillStyle = "white"
            for (face in listFaces) {
                ctx.beginPath()
                ctx.moveTo(face[0].x, face[0].y)
                for (k in 1 until face.size - 1) {
                    ctx.lineTo(face[k].x, face[k].y)
                }
                ctx.lineTo(face.last().x, face.last().y)
                ctx.closePath()
                ctx.fill()
            }

            ctx.fillStyle = "white"

            listOrigFaces = listOf(accelargeSmallTriangle)
            listFaces = mutableListOf<List<A2DVertex>>()
            for (face in listOrigFaces) {
                val temp = mutableListOf<A2DVertex>()
                for (v in face) {
                    temp.add(A3DTransform(180.0f + rot.value).doRotTo2D(v).doTrans2D(68.0,85.0))
                }
                listFaces.add(temp)
            }
            ctx.strokeStyle = "white"
            ctx.fillStyle = "white"
            //ctx.translate(68.0, 85.0)
            for (face in listFaces) {
                ctx.beginPath()
                ctx.moveTo(face[0].x, face[0].y)
                for (k in 1 until face.size - 1) {
                    ctx.lineTo(face[k].x, face[k].y)
                }
                ctx.lineTo(face.last().x, face.last().y)
                ctx.closePath()
                ctx.fill()
            }
        }
    }
}